export default function MaterialsPage({ lang }) {
  return (
    <section className="section materials-page">
      <div className="materials-hero">
        <h1>{lang === "pl" ? "Materiały Premium" : "Premium Materials"}</h1>
        <p>
          {lang === "pl"
            ? "Nasze obrazy powstają w 100% ręcznie z certyfikowanych, bezpiecznych i trwałych materiałów."
            : "Our artworks are handmade using certified, safe and premium-quality materials."}
        </p>
      </div>

      {/* IKONY CERTYFIKATÓW */}
      <div className="materials-icons">
        <div className="materials-icon-box">
          <img src="/images/Icons/icon_1.png" alt="premium 1" />
          <h4>{lang === "pl" ? "Certyfikaty jakości" : "Quality certified"}</h4>
          <p>
            {lang === "pl"
              ? "Materiały użyte w naszych obrazach spełniają najwyższe normy jakości oraz bezpieczeństwa."
              : "All materials meet the highest standards of quality and safety."}
          </p>
        </div>

        <div className="materials-icon-box">
          <img src="/images/Icons/icon_2.png" alt="Oeko Tex" />
          <h4>OEKO-TEX® Standard 100</h4>
          <p>
            {lang === "pl"
              ? "Tkaniny posiadają certyfikat OEKO-TEX® Standard 100, potwierdzający brak szkodliwych substancji."
              : "Fabrics are certified OEKO-TEX® Standard 100, ensuring they are free from harmful substances."}
          </p>
        </div>

        <div className="materials-icon-box">
          <img src="/images/Icons/icon_3.png" alt="handmade" />
          <h4>{lang === "pl" ? "Ręczne wykonanie" : "Handcrafted"}</h4>
          <p>
            {lang === "pl"
              ? "Każdy obraz jest wykonany ręcznie z troską o każdy detal."
              : "Every artwork is handcrafted with care for every detail."}
          </p>
        </div>
      </div>

      {/* SEKCJA O OEKO TEX */}
      <div className="materials-section">
        <h2>OEKO-TEX® Standard 100</h2>
        <p>
          {lang === "pl"
            ? "To jeden z najbardziej rozpoznawalnych na świecie certyfikatów bezpieczeństwa tekstyliów. Oznacza, że materiał został przebadany pod kątem ponad 300 substancji szkodliwych i może być bezpiecznie stosowany nawet w produktach dla dzieci."
            : "This is one of the world’s most recognized textile safety certificates. It confirms the fabric has been tested for over 300 harmful substances and is safe even for children's products."}
        </p>
      </div>

      {/* SEKCJA PREMIUM */}
      <div className="materials-premium">
        <h2>{lang === "pl" ? "Dlaczego nasze materiały?" : "Why our materials?"}</h2>

        <div className="materials-premium-grid">
          <div>
            <h4>✔ {lang === "pl" ? "Mięsista struktura" : "Soft & dense texture"}</h4>
            <p>
              {lang === "pl"
                ? "Tkaniny mają luksusową, miękką strukturę idealną do tworzenia obrazów premium."
                : "Premium soft-touch texture perfect for textile artworks."}
            </p>
          </div>

          <div>
            <h4>✔ {lang === "pl" ? "Głęboka kolorystyka" : "Deep colours"}</h4>
            <p>
              {lang === "pl"
                ? "Barwy są trwałe, odporne na blaknięcie i prezentują się wyjątkowo elegancko."
                : "Colours are durable and remain vivid and elegant for years."}
            </p>
          </div>

          <div>
            <h4>✔ {lang === "pl" ? "Trwałość na lata" : "Long-lasting durability"}</h4>
            <p>
              {lang === "pl"
                ? "Materiały zachowują swoją formę przez wiele lat, nie odkształcają się i nie mechacą."
                : "Materials stay in perfect condition for many years without deforming."}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
